import React, { forwardRef } from "react";
import sass from "pages/References/BusinessProcessRegistry/register.module.sass";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ActionMenuEdit } from "images/EditorIcon.svg";
import { ReactComponent as CurvedLine } from "images/curved_line.svg";
import { ReactComponent as RemoveIcon } from "images/TrashCan.svg";
import { ReactComponent as RestoreIcon } from "images/Refresh.svg";
import { BusinessProcessPatternResponse } from "libs/apiClient/data-contracts";

interface IDropDownProps {
	remove: () => void;
	restoreTemplate: () => void;
	target: HTMLOrSVGElement | undefined;
	data: BusinessProcessPatternResponse[];
	setCurrent: (str: string) => void;
	editTemplate: () => void;
	confirmArchive: () => void;
	current: string | number;
	archive: boolean;
}

const DropDown = forwardRef<HTMLDivElement | null, IDropDownProps>(
	({ target, archive, confirmArchive, data, editTemplate, restoreTemplate, setCurrent, remove, current }, ref) => {
		const navigate = useNavigate();
		return (
			<DropMenu ref={ref} addClass={false} target={target} click={remove} clear>
				{archive ? (
					<p className={sass.dropItem} onClick={restoreTemplate}>
						<RestoreIcon width={14} /> Восстановить
					</p>
				) : (
					<>
						<p className={sass.dropItem} onClick={editTemplate}>
							<ActionMenuEdit width={14} className={sass.edit} /> Редактировать
						</p>
						<p
							className={sass.dropItem}
							onClick={() => {
								navigate(`${current}`);
								setCurrent("");
							}}>
							<CurvedLine width={14} className={sass.curved} /> Заполнить шаблон
						</p>
						<p className={sass.dropItem} onClick={confirmArchive}>
							<RemoveIcon className={sass.remove} width={14} /> Переместить в архив
						</p>
					</>
				)}
			</DropMenu>
		);
	},
);

export default DropDown;
